import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, type, parentFolder, folder }) =>
    present(
      repository
        .saveFolder(parentFolder, {
          ...folder,
          ...(type === "project" ? { projectUuid: namespace } : {}),
          ...(type === "planzone" ? { planzoneUuid: namespace } : {}),
        })
        .then((folder) => ({ namespace, type, parentFolder, folder }))
        .catch(() => Promise.reject({ namespace, type, parentFolder, folder })),
    );
}

export type { Interactor };

export { createInteractor };
